import React, { ReactNode } from "react";
import { CalendarDayWrap } from "./CalendarUI";

/*
Usage:
<Day number={13} name="Friday" month="October"></Day>
*/

interface CalendarDayProps {
    number: number;
    name: string;
    month: string;
    children?: ReactNode;
}

const CalendarDay: React.FC<CalendarDayProps> = (props) => (
    <CalendarDayWrap>
        <div className="calendar__date">
            <span className="calendar__day-number">{props.number}</span>
            <span className="calendar__day-month">
                <span className="calendar__date-month">{props.month}</span>
                <span className="calendar__day-name">{props.name}</span>
            </span>
        </div>
        <div className="calendar__events">
            {props.children}
        </div>
    </CalendarDayWrap>
);

export default CalendarDay;